import { Button } from 'react-bootstrap';
import evento from 'assets/img/evento.png';
import canje from 'assets/img/canje.png';
import regalo from 'assets/img/regalo.png';
import comparte from 'assets/img/comparte.png';
import './style.scss';
import { Link } from 'react-router-dom';
import { setLoginRedirectSSO } from 'util/navigation';
import { useWindowSize } from 'hooks';

const HomeStepCard = ({ title, link, tagUrl, image, subtitulo }) => (
  <div className="HomeSteps__card d-flex justify-content-between flex-column align-items-center">
    <div>
      <img src={image} className="my-2 ilustracion" alt="" loading="lazy" />
    </div>
    <div className="d-flex justify-content-between">
      <p className="HomeSteps__card__title">{title}</p>
    </div>
    <div className="d-flex justify-content-between">
      <p className="HomeSteps__card__subtitle">{subtitulo}</p>
    </div>
    <div className="HomeSteps__card__controls d-flex flex-column align-items-center">
      {tagUrl && (
        <a className="link-button" href={tagUrl}>
          <Button block variant="primary" type="button">
            {link}
          </Button>
        </a>
      )}
    </div>
  </div>
);

const HomeStepCardNew = ({ title, link, tagUrl, image, subtitulo }) => (
  <div className="HomeSteps__card d-flex justify-content-between flex-column align-items-center">
    <div>
      <img src={image} alt="" loading="lazy" />
    </div>
    <div className="d-flex justify-content-between">
      <p className="HomeSteps__card__title">{title}</p>
    </div>
    <div className="d-flex justify-content-between">
      <p className="HomeSteps__card__subtitle">{subtitulo}</p>
    </div>
    <div className="HomeSteps__card__controls d-flex flex-column align-items-center">
      {tagUrl !== '' ?
        <Link to={tagUrl} className='link'>{link}</Link>
        : link
      }
    </div>
  </div>
);

const HomeSteps = ({ isLoggedIn, setLoginRedirect }) => {

  const [, { isMobile }] = useWindowSize()

  return (
    <section className="HomeSteps">
      <div className="container">
        <h2 className={`text-center ${!isMobile && 'my-5'} title-events`}><strong>¿Cómo funciona?</strong></h2>
        <div className={!isMobile && "row"}>
          <div className="col text-center"> {/* Añadimos la clase 'text-center' aquí */}
            <HomeStepCardNew
              title="1. Selecciona tu evento"
              subtitulo="Selecciona tu evento dentro de nuestro catálogo."
              //link="Ver eventos"
              // tagUrl={`${PROJECT_BASENAME}#eventos`}
              tagUrl=''
              image={evento}
            />
          </div>
          <div className="col text-center"> {/* Añadimos la clase 'text-center' aquí */}
            <HomeStepCardNew
              title="2. Decide la forma de canje"
              subtitulo="Recibe los regalos que escogiste en casa o convierte tus regalos en un monedero electrónico."
              link="Ver planes"
              // tagUrl={`${PROJECT_BASENAME}planes`}
              tagUrl='/planes'
              image={canje}
            />
          </div>
        </div>
        <div className={!isMobile && "row"}>
          <div className="col text-center"> {/* Añadimos la clase 'text-center' aquí */}
            <HomeStepCardNew
              title="3. Crea tu mesa y elige tus regalos"
              subtitulo="Personaliza tu página web y elige los productos de nuestro catálogo"
              //link="Ver catálogo"
              tagUrl=""
              image={regalo}
            />
          </div>
          <div className="col text-center"> {/* Añadimos la clase 'text-center' aquí */}
            <HomeStepCard
              title="4. Comparte tu mesa"
              subtitulo="Crea tus invitaciones digitales, comparte tu código QR y recibe notificaciones en tiempo real cada vez que te regalen algo."
              link="Crear mesa"
              tagUrl={setLoginRedirectSSO('crear-mesa', true, isLoggedIn, true)}
              image={comparte}
            />
          </div>
        </div>


        {/* }
      <div className="row">
        <div className="col">
          <h2 className="text-center my-5"><strong>¿Cómo funciona?</strong></h2>
          <div className="row">
            <div className="col">
              <Slider {...carouselConfig} withSpace>
                <HomeStepCardNew
                  title="1. Selecciona tu evento"
                  subtitulo="Selecciona tu evento dentro de nuestro catálogo."
                  link="Ver eventos"
                  tagUrl={`${PROJECT_BASENAME}#eventos`}
                  image={paso1}
                />
                <HomeStepCardNew
                  title="2. Decide la forma de canje"
                  subtitulo="Recibe los regalos que escogiste en casa o convierte tus regalos en un monedero electrónico."
                  link="Ver planes"
                  tagUrl={`${PROJECT_BASENAME}planes`}
                  image={paso2}
                />
                <HomeStepCardNew
                  title="3. Crea tu mesa y elige tus regalos"
                  subtitulo="Personaliza tu página web y elige los productos de nuestro catálogo"
                  link="Ver catálogo"
                  tagUrl="#"
                  image={paso3}
                />
                <HomeStepCard
                  title="4. Comparte tu mesa"
                  subtitulo="Crea tus invitaciones digitales, comparte tu código QR y recibe notificaciones en tiempo real cada vez que te regalen algo."
                  link="Crear mesa"
                  tagUrl={setLoginRedirect('crear-mesa', true, isLoggedIn, true)}
                  image={paso4}
                />
              </Slider>
            </div>
          </div>
        </div>
      </div> */}
      </div>
    </section >
  );
};

export default HomeSteps;
